﻿$.fn.dxCtrlContentDemandeNewSupport = function custom_dxCtrlContentDemandeNewSupport(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcontentdemandenewsupport dx-ctrl");
        this.createInstance(new cdxCtrlContentDemandeNewSupport(this, option));
    }
    return this;
}

window.cdxCtrlContentDemandeNewSupport = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var jauge = null
    function mConstruit() {
        container.empty();
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()
        var $TableTop = $("<table style='width:calc(100% - 10px);table-layout:fixed;margin:5px 5px 0 5px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($TableTop)
        var $Td = $("<td style='width:45px'><i class='fas fa-user-doctor' style='font-size:35px;'></i></td>").appendTo($Tr)
        var $Td = $("<td style='width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:140%;'>Nouveau ticket de support</td>").appendTo($Tr)
        var $Td = $("<td style='width:45px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-window-maximize",
            onClick: function (e) {
                if (container.parent().css("max-width") == "none") {
                    container.parent().css("max-width", "600px")
                } else {
                    container.parent().css("max-width", "")
                }
            }
        })
        var $Td = $("<td style='width:45px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-xmark",
            hint: (option.isGestionnaire ? "Supprimer le ticket et quitter" : "Quitter"),
            onClick: function (e) {
                if (option.isGestionnaire) {
                    if (dataTicketNew.id_support_ticket) option.bddCtrl.getObjet(dataTicketNew).mDelDataDefinitif()
                    option.onClose()
                } else if (dxContentEmailBaseDemande.isDirty()) {
                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: e.component.element(),
                        position: "bottom",
                        contentTemplate: function (contentElement) {
                            contentElement.css("font-size", "110%")
                            contentElement.css("padding", "20px")
                            $("<div style='padding-bottom:20px;'>Vous n'avez pas créé le ticket<br/>Quitter sans sauvegarder?</div>").appendTo(contentElement)
                            $("<div/>").appendTo(contentElement).dxCtrlButton({
                                text: "Quitter sans sauvegarder",
                                width: "100%",
                                onClick: function (e) {
                                    option.onClose()
                                    jauge.mHide()
                                    tt.hide()
                                }
                            })
                            $("<div/>").appendTo(contentElement).dxCtrlButton({
                                text: "Créer le ticket & quitter",
                                width: "100%",
                                onClick: function (e) {
                                    mSave()
                                    tt.hide()
                                }
                            })

                        }
                    }).dxCtrlTooltip("instance")
                    tt.show()
                } else {
                    option.onClose()
                }
            }
        })

        $DivDetailTotal = $("<div style='height:calc(100% - " + $TableTop.innerHeight() + "px);padding: 10px 20px 20px 20px;'/>").appendTo(container)
        resizeObserver.mAdd($TableTop, function () { $DivDetailTotal.css("height", "calc(100% - " + $TableTop.innerHeight() + "px)") })

        mConstruitTicket()
    }

    var dxContentEmailBaseDemande = null
    var dxContentEmailBaseReponse = null
    var dataTicketNew = null
    var dataTicketReponseSupport = null
    function mConstruitTicket() {

        dataTicketNew = option.bddCtrl.getObjet("support_ticket").mGetNewData()
        dataTicketNew.id_compte_client = option.idCompteClient
        dataTicketNew.id_utilisateur_client = option.idUtilisateurClient

        $DivValide1 = $("<div style='text-align:right;'/>").appendTo($DivDetailTotal)
        $("<div style='display:inline-block;margin-bottom:10px;'/>").appendTo($DivValide1).dxCtrlButton({
            text: "Créer le ticket",
            onClick: function (e) {
                mSave()
            },
            onContentReady: function (e) {
                window.setTimeout(function () {
                    mResize()
                }, 100)
            }
        })

        dxContentEmailBaseDemande = $("<div style='width:100%;height:100%;'/>").appendTo($DivDetailTotal).dxCtrlContentEmailBase({
            bddCtrl: option.bddCtrl,
            labelObjet: "Objet de votre ticket",
            readOnly: false,
            data: dataTicketNew,
            saveAuto: false,
            allowAssistant: false,
            allowMiseEnPage: false,
            allowMenu: false,
            allowTag: false,
            allowFullScreen: false,
            allowShowMessageNavigateur: false,
            hideToolbarPrevi: true,
            removeMenuFont: false,
            lstUrlFileJoinStart: option.lstUrlFileJoinStart,
            showOnlyUploadMachine: true,
            onContentReady: function (component) {
                if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })
                jauge.mHide()
                component.focus()
            }
        }).dxCtrlContentEmailBase("instance")

        if (option.isGestionnaire) {
            dataTicketNew.envoi_mail = 1
            //c'est le gestionnaire qui initie un ticket pour un utilisateur
            dataTicketReponseSupport = option.bddCtrl.getObjet("support_ticket").mGetNewData()
            dataTicketReponseSupport.id_compte_client = option.idCompteClient
            dataTicketReponseSupport.id_utilisateur_client = option.idUtilisateurClient
            dataTicketReponseSupport.id_utilisateur_gest = option.idUtilisateurGest
            dataTicketReponseSupport.id_support_ticket_parent = dataTicketNew.id_support_ticket

            dxContentEmailBaseDemande.mChangeHtml(
                "<html>" +
                "<body>" +
                "<div>" +
                "Ce ticket a été créé par le service support<br/>pour vous faire un retour sur une demande ou initier un ticket sur une question." +
                "</div>" +
                "</body>" +
                "</html>",
                "<div>" +
                "Ce ticket a été créé par le service support<br/>pour vous faire un retour sur une demande ou initier un ticket sur une question." +
                "</div>", function () { })

            dxContentEmailBaseReponse = $("<div style='width:100%;height:100%;'/>").appendTo($DivDetailTotal).dxCtrlContentEmailBase({
                bddCtrl: option.bddCtrl,
                showObjet: false,
                readOnly: false,
                data: dataTicketReponseSupport,
                saveAuto: false,
                allowAssistant: false,
                allowMiseEnPage: false,
                allowMenu: false,
                allowTag: false,
                allowFullScreen: false,
                allowShowMessageNavigateur: false,
                hideToolbarPrevi: true,
                removeMenuFont: false,
                lstUrlFileJoinStart: option.lstUrlFileJoinStart,
                showOnlyUploadMachine: true,
                onContentReady: function (component) {
                    if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })
                    jauge.mHide()
                    component.focus()
                }
            }).dxCtrlContentEmailBase("instance")
        }

        $DivValide2 = $("<div style='text-align:right;'/>").appendTo($DivDetailTotal)
        $("<div style='display:inline-block;margin-top:10px;'/>").appendTo($DivValide2).dxCtrlButton({
            text: "Créer le ticket",
            onClick: function (e) {
                mSave()
            },
            onContentReady: function (e) {
                window.setTimeout(function () {
                    mResize()
                }, 100)
            }
        })
    }

    function mSave() {
        jauge.mShow()
        dxContentEmailBaseDemande.mSaveAuto(function () {
            if (dxContentEmailBaseReponse) {
                dxContentEmailBaseReponse.mSaveAuto(function () {
                    dataTicketNew.tempo = "0"
                    dataTicketNew.envoi_mail = "1"
                    dataTicketNew.lu = 0
                    option.bddCtrl.getObjet(dataTicketNew).mSave(function (data) {
                        dataTicketReponseSupport.tempo = "0"
                        dataTicketReponseSupport.id_support_ticket_parent = dataTicketNew.id_support_ticket
                        option.bddCtrl.getObjet(dataTicketReponseSupport).mSave(function (data) {
                            mNotify("Votre ticket de support pour l'utilisateur a été créée.", "success", 6000)
                            option.onClose()
                            jauge.mHide()
                        })
                    })
                })
            } else {
                dataTicketNew.tempo = "0"
                option.bddCtrl.getObjet(dataTicketNew).mSaveChamp('tempo', function (data) {
                    mNotify("Votre ticket de support a été créée.", "success", 6000)
                    option.onClose()
                    jauge.mHide()
                })
            }
        })
    }

    function mResize() {
        if (dxContentEmailBaseDemande) {
            if (dxContentEmailBaseReponse) {
                dxContentEmailBaseDemande.element().css("height", "30%")
                dxContentEmailBaseReponse.element().css("height", "calc(70% - " + ($DivValide1.innerHeight() + $DivValide2.innerHeight()) + "px)")
            } else {
                dxContentEmailBaseDemande.element().css("height", "calc(100% - " + ($DivValide1.innerHeight() + $DivValide2.innerHeight()) + "px)")
            }
        }

    }

    this.element = function () { return container }

    mConstruit();

}